import React, { useEffect, useState } from 'react';
import { WarningCircle } from '@phosphor-icons/react';
import { registerConfirmHost } from '../../utils/confirmDialog';
import { useLanguage } from '../../contexts/LanguageContext';

export const ConfirmDialogHost = () => {
  const { t } = useLanguage();
  const [request, setRequest] = useState(null);

  useEffect(() => registerConfirmHost(setRequest), []);

  const answer = (value) => {
    request?.resolve(value);
    setRequest(null);
  };

  useEffect(() => {
    if (!request) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') answer(false);
      if (e.key === 'Enter') answer(true);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  });

  if (!request) return null;
  const { title, message, confirmLabel, cancelLabel, destructive } = request;

  return (
    <div
      className="fixed inset-0 z-[130] flex items-center justify-center bg-black/50 p-4"
      onClick={() => answer(false)}
      data-testid="confirm-dialog"
    >
      <div
        className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl animate-fade-in"
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
      >
        <div className={`mb-4 flex h-11 w-11 items-center justify-center rounded-full ${destructive ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-600'}`}>
          <WarningCircle size={24} weight="duotone" />
        </div>
        <h3 className="font-display text-lg font-semibold text-gray-900" data-testid="confirm-dialog-title">{title}</h3>
        {message && <p className="mt-1.5 text-sm text-gray-600" data-testid="confirm-dialog-message">{message}</p>}
        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={() => answer(false)}
            data-testid="confirm-dialog-cancel-btn"
            className="rounded-xl px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors"
          >
            {cancelLabel || t('cancel')}
          </button>
          <button
            onClick={() => answer(true)}
            autoFocus
            data-testid="confirm-dialog-confirm-btn"
            className={`rounded-xl px-4 py-2 text-sm font-semibold text-white transition-colors ${destructive ? 'bg-red-600 hover:bg-red-700' : 'bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700'}`}
          >
            {confirmLabel || 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialogHost;
